// The base every environment is built on, and so the shape of the whole config: what an environment
// does not say, it takes from here. A deploy always overwrites the infrastructure half — origins and
// Cognito come from what Terraform publishes — so the values carried here are the ones that make a
// plain `npm run dev` work: they point at dev, whose Cognito pool registers localhost among its
// callback URLs.
import base from "../runtime-envs/default.json";

if (!window.env) {
	console.warn("window.env not found, defaulting to the base config");
}

// Annotated rather than inferred: the fallback carries no `sphereAI` (only a deployed environment
// does), and an inferred union of the two shapes would make the optional key unreadable instead of
// optional. See declarations/window.d.ts.
const env: NonNullable<Window["env"]> = window.env ?? base;

export default env;
